<template>
  <div>
    <b-modal
      v-model="modalStatus"
      centered
      size="md"
      button-size="sm"
      no-close-on-backdrop
    >
      <template #modal-header>
        <h5 class="modal-title">Save Searchquery</h5>
        <button type="button" class="close" @click="closeModal()">×</button>
      </template>
      <b-alert v-model="hasUnknownError" variant="danger" fade>
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger" fade>
        {{ errorMessage }}
      </b-alert>

      <validation-observer ref="observer" v-slot="{ passes }">
        <b-form @submit.prevent="passes(onSubmit)">
          <b-form-row>
            <b-col lg="12">
              <validation-provider vid="title" rules="required" v-slot="{ valid, errors, changed }">
                <b-form-input
                  v-model="searchquery.title"
                  type="text"
                  :state="onValidateField(valid, errors, changed)"
                  placeholder="Title"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-form-row>
          <b-row>
            <b-col lg="12" class="right">
              <b-button type="submit" variant="primary" size="sm" disabled v-if="isSubmitting" class="mt-4">
                <b-spinner small></b-spinner>
                Save
              </b-button>
              <b-button class="mt-4" type="submit" size="sm" variant="primary" ref="submitEditPlotBtn" v-else>Save</b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            hidden
          >
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="modalAlert"
      centered
      size="sm"
      button-size="sm"
      no-close-on-backdrop
      title="Alert"
      @show="resetModal"
      @hidden="resetModal"
      @ok="overwriteTemplate"
      cancelTitle="No"
      okTitle="Yes"
    >A searchquery with this name already exists. Replace existing query?
    </b-modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { validateField } from '@/helpers/formHelper.js'
  export default {
    name: 'save-searchquery',
    components: {
      ValidationObserver,
      ValidationProvider
    },
    props: {
      searchquery: Object
    },
    data () {
      return {
        isSubmitting: false,
        hasUnknownError: false,
        unknownErrorMessage: '',
        hasError: false,
        errorMessage: '',
        modalAlert: false
      }
    },
    created () {
    },
    methods: {
      onSubmit () {
        this.checkTemplateByTitle()
      },
      async checkTemplateByTitle () {
        try {
          const { errors } = await this.$store.dispatch('template/GET_TEMPLATE_BY_TITLE', {
            formData: this.searchquery
          })
          if (!errors) {
            if (this.matchingTemplates.length) {
              this.modalAlert = true
            } else {
              this.createTemplate()
            }
          } else {
            throw errors
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async createTemplate () {
        try {
          const { errors } = await this.$store.dispatch('template/CREATE_TEMPLATE', {
            formData: this.searchquery
          })
          if (!errors) {
            this.$store.commit('template/SET_SAVE_QUERY_STATUS', false)
            this.getTemplates()
          } else {
            throw errors
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async overwriteTemplate () {
        this.modalAlert = false
        const overwriteTemplate = {
          id: this.matchingTemplates[0].field_001,
          state: this.searchquery.state
        }
        try {
          const { errors } = await this.$store.dispatch('template/UPDATE_TEMPLATE', {
            formData: overwriteTemplate
          })
          if (!errors) {
            this.$store.commit('template/SET_SAVE_QUERY_STATUS', false)
            this.getTemplates()
          } else {
            throw errors
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async getTemplates () {
        try {
          const { errors } = await this.$store.dispatch('template/GET_TEMPLATES_SEARCHQUERY')
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      resetModal () {
        this.modalAlert = false
      },
      closeModal () {
        this.$store.commit('template/SET_SAVE_QUERY_STATUS', false)
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    },
    computed: {
      ...mapState({
        modalStatus: state => state.template.saveQueryStatus,
        matchingTemplates: state => state.template.matchingTemplates
      })
    }
  }
</script>
